import { ObjectsView, Table, ViewBar, ViewMenu } from "@organisms"
import TableView from "@organisms/ObjectsView/TableView/TableView"

import { CatalogItemObjectsViewTabs } from "@pages/Settings/SettingsCatalogs/SettingsCatalogsItemList/CatalogItemObjectsViewTabs"
import { getCategoryTitle } from "@pages/Settings/SettingsCatalogs/SettingsCatalogsItemList/SettingsCatalogsItemList.utils"
import SubscribeItemCell from "@pages/Settings/SettingsCatalogs/SettingsCatalogsItemList/components/SubscribeItemCell/SubscribeItemCell"

import { CatalogItemTableViewProps } from "./CatalogItemTableView.types"

export default function CatalogItemTableView(props: CatalogItemTableViewProps) {
    const { catalogId, brandParam, categories } = props

    return (
        <>
            <ViewBar.Root>
                <ViewBar.Start>
                    <CatalogItemObjectsViewTabs
                        catalogId={catalogId}
                        brandParam={brandParam}
                        categories={categories}
                    />
                </ViewBar.Start>
                <ViewBar.End>
                    <ObjectsView.SearchInput />
                    <ViewMenu />
                </ViewBar.End>
            </ViewBar.Root>
            <TableView.Table>
                <Table.Column<CatalogItem>
                    accessorKey="thumbnail_url"
                    header="Image"
                    size={80}
                    cell={({ getValue, row }) => (
                        <Table.Cells.ImageCell src={getValue()} fallbackName={row.original.name} />
                    )}
                    enableSorting={false}
                    enablePinning={true}
                    dataType="other"
                />
                <Table.Column<CatalogItem>
                    accessorKey="name"
                    header="Name"
                    size={288}
                    cell={({ getValue }) => <Table.Cells.TextCell content={getValue()} />}
                    enableSorting={true}
                    enablePinning={true}
                    dataType="alphabetical"
                />
                <Table.Column<CatalogItem>
                    accessorKey="sku"
                    header="SKU"
                    size={144}
                    cell={({ getValue }) => <Table.Cells.TextCell content={getValue()} />}
                    enableSorting={true}
                    enablePinning={false}
                    dataType="alphabetical"
                />
                <Table.Column<CatalogItem>
                    accessorKey="categories"
                    header="Categories"
                    size={240}
                    cell={({ row }) => (
                        <Table.Cells.BadgesCell badges={row.original.categories.map(getCategoryTitle)} />
                    )}
                    enableSorting={false}
                    enablePinning={false}
                    dataType="other"
                />
                <Table.Column<CatalogItem>
                    accessorKey="list_price"
                    header="List Price"
                    size={128}
                    cell={({ getValue }) => <Table.Cells.NumericalDataCell value={getValue()} type="currency" />}
                    enableSorting={true}
                    enablePinning={false}
                    dataType="numerical"
                    alignment="right"
                />
                <Table.Column<CatalogItem>
                    accessorKey="customer_price"
                    header="Your Price"
                    size={128}
                    cell={({ getValue }) => <Table.Cells.NumericalDataCell value={getValue()} type="currency" />}
                    enableSorting={true}
                    enablePinning={false}
                    dataType="numerical"
                    alignment="right"
                />
                <Table.Column<CatalogItem>
                    accessorKey="id"
                    header="Subscription"
                    size={160}
                    cell={({ row }) => <SubscribeItemCell row={row.original} catalogId={catalogId} />}
                    enableSorting={false}
                    enablePinning={false}
                    dataType="other"
                />
            </TableView.Table>
        </>
    )
}
